import { ObjectMap } from '../common/interfaces'

export async function sendToEndpoint(endpointUrl: string, payload: ObjectMap) {
  const jsonBody: RequestInit = {
    method: 'POST',
    credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      'Content-Type': 'application/json',
    },
    referrerPolicy: 'no-referrer-when-downgrade', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    body: JSON.stringify(payload),
  }

  const response = await fetch(endpointUrl, jsonBody)
  return response
}
